export class LocationFilterEvent {
    soonestAvailable: boolean = false;
    on: boolean = false;
    by: boolean = false;
    numberOfAppointments: number = null;
    filterDate: Date = null;
    reset: boolean = false;

    constructor(soonestAvail: boolean = false, on: boolean = false, by: boolean = false,
                numberAppts: number = null, filterDate: Date = null, reset: boolean = false) {
        this.soonestAvailable = soonestAvail;
        this.on = on;
        this.by = by;
        this.numberOfAppointments = numberAppts;
        this.filterDate = filterDate;
        this.reset = reset;
    }
}
